function bem(className, baseClass, modifier) {
  var classNames = Array.isArray(className) ? className : [className];
  return classNames.map(function (cls) {
    return "".concat(baseClass).concat(modifier).concat(cls);
  }).join(' ');
}
export var e = function e(className, baseClass) {
  return bem(className, baseClass, '__');
};
export var m = function m(className, baseClass) {
  return bem(className, baseClass, '--');
};